<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="body_Praise--Heading3-">Also by Mitzi<span class="noBreak"> </span>Szereto</p>
<p class="body_Body ParaOverride-1">The Best New True Crime Stories: Seri<span class="noBreak">al</span><span class="noBreak"> </span><span class="noBreak">Killers</span></p>
<p class="body_Body ParaOverride-2">The Best New True Crime Stories: S<span class="noBreak">mall</span><span class="noBreak"> </span><span class="noBreak">Towns</span></p>
<p class="body_Body ParaOverride-2">The Best New True Crime Stories: Well-Mannered Crooks, Rogues &amp;<span class="noBreak"> Criminals</span></p>
<p class="body_Body ParaOverride-2">The Best New True Crime Stories: Crimes of Passion, Obsession<span class="noBreak"> &amp; Revenge</span></p>
<p class="body_Body ParaOverride-2">The Best New True Crime Stories: Partner<span class="noBreak">s in</span><span class="noBreak"> </span><span class="noBreak">Crime</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TheBestNewTrueCrimeStories-2.vue?016ee4b6